import React from 'react'
import HomeMonth from '../gobal/HomeMonth/HomeMonth'
import HomePersona from '../gobal/HomePersona/HomePersona'
import HomeSavedSearches from '../gobal/HomeSavedSearches/HomeSavedSearches'
import HomeSidebar from '../gobal/HomeSidebar/HomeSidebar'
import HomeSectionTeam from '../gobal/HomeTeam/HomeSectionTeam'
import TitleSubTitle from '../gobal/TitleSubTitle'
// import { NavLink } from 'react-router-dom'
import GlobalLayout from '../layout/GlobalLayout'
import TopMenu from '../layout/TopMenu'
import { UserStatusGoPage } from '../lib/userStatus'

export default function Home() {
    UserStatusGoPage("/")
    return (
        <GlobalLayout showTopMenu={false} >
            <TopMenu />
            <div className='px-10' >
                <div className='pt-10 pb-12 lg:pl-16'>
                    <TitleSubTitle title="What are you looking for today?" subtitle="Hello, nice to see you again!" />
                </div>

                <div className='flex md:flex-row flex-col pb-[3.438rem]'>
                    <div className='w-full lg:w-[72%] md:pl-14'>
                        <HomeSectionTeam />
                        <HomeSavedSearches />
                        <HomeMonth />
                    </div>
                    <div className='border-l-2 border-mainColor ml-14'>
                        <HomeSidebar />
                    </div>
                </div>
            </div>
            <div>
                <HomePersona />
            </div>
        </GlobalLayout>
    )
}
